import arrowRightOrange from "../assets/arrowRightOrange.png";
import arrowRight from "../assets/arrowRight.png";
import { useNavigate } from "react-router-dom";
import useOrdersStore from "../store/ordersStore";
import { useEffect } from "react";

const openModal = () => {
  alert("Click");
};

const HistoricOrders = () => {
  const { getAllOrders, orders, loading, error } = useOrdersStore();
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const handleNavigateToOrders = () => {
    navigate("/pedidos");
  };

  const handleNavigateToDetailsOrders = (id, index) => {
    navigate(`/pedidos/detalhes/${id}/${index}`);
  };

  useEffect(() => {
    getAllOrders();
  }, [getAllOrders]);

  return (
    <div className="md:col-span-2 lg:col-span-1 xl:col-span-1  bg-[#F2F2F2] rounded-md p-4">
      <div
        className="flex justify-between cursor-pointer "
        onClick={handleNavigateToOrders}
      >
        <h2 className="text-[16px] ">
          <span className="font-bold text text-boldGray opacity-70 text-base xl:text-xl">
            Histórico de pedidos
          </span>
          <br />
        </h2>
        <div className="flex items-center">
          <img src={arrowRight} alt="" />
        </div>
      </div>
      <div className="mt-8">
        {orders.length === 0 ? (
          <>
            <p className="font-bold text-boldGray text-xl">
              Ainda não há pedidos cadastrados
            </p>
          </>
        ) : (
          <div
            className={`h-[500px] overflow-y-auto custom-scrollbar ${
              orders.length > 7 && "pr-4"
            }`}
          >
            {orders.map((item, index) => (
              <div
                key={index}
                className={`border xl:px-2 xl:py-3.5 lg:px-1 lg:py-2 md:py-3 md:px-2 rounded flex items-center justify-between bg-[#E7E7E7] text-boldGray opacity-90 cursor-pointer ${
                  index === orders.length - 1 ? "" : "mb-2"
                }`}
                onClick={() =>
                  handleNavigateToDetailsOrders(item.id, index + 1)
                }
              >
                <p>
                  <span className="text-[#FF9533] font-bold lg:text-xs xl:text-base">
                    P00{index + 1}-{year}
                  </span>
                </p>
                <p className="text-center text-xs">
                  <span className="font-bold uppercase text-xs">
                    {item.status}
                  </span>{" "}
                  <br />
                  {new Intl.DateTimeFormat("pt-BR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  }).format(new Date(item.createdAt))}
                </p>
                <p className="text-center text-xs">
                  <span className="font-bold uppercase text-center text-xs">
                    Previsão{" "}
                  </span>{" "}
                  <br />
                  -----
                </p>
                <button onClick={openModal}>
                  <img src={arrowRightOrange} alt="" />
                </button>
              </div>
            ))}{" "}
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoricOrders;
